import classnames from "classnames";

const ImagePlaceholder = ({ className = "", ...props }) => (
  <div
    data-testid="fallback-image"
    className={classnames("neeto-ui-bg-gray-100", {
      [className]: className,
    })}
    {...props}
  />
);

export default ImagePlaceholder;
